import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacySelectionListChange as MatSelectionListChange } from '@angular/material/legacy-list';

export interface FilterOption {
  label: string;
  value: string;
}

/**
 * Generic multi-select filter column (used for Sentiment and Language).
 */
@Component({
  selector: 'app-filter-simple-list',
  templateUrl: './filter-simple-list.component.html',
  styleUrls: ['./filter-simple-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterSimpleListComponent {
  @Input() header: string;
  @Input() listClass: string;
  @Input() optionClass: string;
  @Input() options: FilterOption[] = [];
  @Input() control: UntypedFormControl;
  /** language list shows a BETA badge for non en/de options */
  @Input() showBetaBadge = false;

  @Output() selectionChange = new EventEmitter<MatSelectionListChange>();

  isBeta(value: string): boolean {
    return this.showBetaBadge && !['en', 'de'].includes(value);
  }
}
